/** Values come from `GET /api/authMethod` and cannot be renamed here. */
export enum AuthMethod {
    API_KEY = "apiKey",
    OAUTH = "oauth",
}

const LAST_LOGIN_METHOD_KEY = "xola.auth.lastLoginMethod";

export const recordOAuthLogin = () => localStorage.setItem(LAST_LOGIN_METHOD_KEY, AuthMethod.OAUTH);

export const clearLastLoginMethod = () => localStorage.removeItem(LAST_LOGIN_METHOD_KEY);

export const wasLastLoginOAuth = () => localStorage.getItem(LAST_LOGIN_METHOD_KEY) === AuthMethod.OAUTH;

/**
 * First rule that matches wins:
 *
 * 1. an `apiKey` arrived in the URL hash — an explicit credential handover (impersonation, account
 *    switch). The hash is stripped at module load, so the caller passes what it captured.
 * 2. `?authMethod=oauth` or `?authMethod=apiKey` — the development override
 * 3. the last login used OAuth — resume it rather than sending the user to log in again
 * 4. nothing local — return null and let the caller ask the server
 */
export const resolveAuthMethod = (hasAPIKeyinHash: boolean): AuthMethod | null => {
    if (hasAPIKeyinHash) {
        clearLastLoginMethod();
        return AuthMethod.API_KEY;
    }

    const urlParam = new URLSearchParams(window.location.search).get("authMethod");

    if (urlParam === AuthMethod.OAUTH) {
        return AuthMethod.OAUTH;
    }

    if (urlParam === AuthMethod.API_KEY) {
        return AuthMethod.API_KEY;
    }

    if (wasLastLoginOAuth()) {
        return AuthMethod.OAUTH;
    }

    return null;
};
